module.exports = __webpack_public_path__ + "static/media/email_viejo.3a5f320e.svg";